import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg viewBox="0 0 240 300" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="10" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="50" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="90" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="130" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="170" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="210" width="94%" height="30" rx="2" />
        </g>
        <g fillOpacity="0.14" fill="#8E90A2">
            <rect x="3%" y="250" width="94%" height="30" rx="2" />
        </g>
    </svg>
);

const DropDownListLoadingIndicator = (props) => (
    <RootWrapper {...props}>
        <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default DropDownListLoadingIndicator;
